import axios from "axios";
import { ACTION_TYPES } from "./types";
import Cookies from "js-cookie";

// Get server health data
export const getServerHealth = () => async (dispatch) => {
  dispatch(setHealthLoading(true));
  dispatch(setHealthError(null));

  try {
    const baseUrl =
      process.env.REACT_APP_SMS_API || "https://sms.api.averly.com.na";
    const endpoint = `${baseUrl}/api/v1/health`;

    const accessToken = Cookies.get("accessToken");

    const res = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${String(accessToken)}`,
      },
    });

    dispatch({
      type: ACTION_TYPES.GET_SERVER_HEALTH,
      payload: res.data,
    });

    dispatch(setHealthLoading(false));
  } catch (err) {
    console.error("Error fetching server health:", err);

    const errorMessage = err.response?.data?.message || err.message || "Failed to fetch server health";

    dispatch(setHealthError(errorMessage));
    dispatch(setHealthLoading(false));
  }
};

// Get recovery history
export const getRecoveries = (hours = 24) => async (dispatch) => {
  try {
    const baseUrl =
      process.env.REACT_APP_SMS_API || "https://sms.api.averly.com.na";
    const endpoint = `${baseUrl}/api/v1/health/recoveries?hours=${hours}`;

    const accessToken = Cookies.get("accessToken");

    const res = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${String(accessToken)}`,
      },
    });

    dispatch({
      type: ACTION_TYPES.GET_RECOVERIES,
      payload: res.data,
    });
  } catch (err) {
    console.error("Error fetching recoveries:", err);
  }
};

// Set health loading state
export const setHealthLoading = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_HEALTH_LOADING,
    payload,
  });
};

// Set health error state
export const setHealthError = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_HEALTH_ERROR,
    payload,
  });
};
